export const TOAST_ACTIONS = {
  ADD_TOAST: "addToast",
  REMOVE_TOAST: "removeToast"
};

export const TOAST_STATUSES = {
  CRITICAL: "critical",
  INFO: "info",
  SUCCESS: "success",
  WARNING: "warning"
};

export const TOAST_HEADERS = {
  ERROR: "Error",
  SYSTEM_ERROR: "System error"
};

export const TOAST_MESSAGES = {
  GENERIC_ERROR: "Oops! Something went wrong. Please try again.",
  GENERIC_ERROR_NO_RETRY: "Oops! Something went wrong."
};
